(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    /*
   * Cart API errors come back in the shop's admin language (English). Swap them for the Dutch
   * strings on the error wrapper (data-dvk-msg-*). Same logic as dvk-product.js; whichever
   * loads first handles every wrapper on the page.
   */
  (function () {
    if (window.dvkCartErrorsTranslated) return;
    window.dvkCartErrorsTranslated = true;

    var translate = function (wrapper) {
      var target = wrapper.querySelector('.product-form__error-message');
      if (!target || !wrapper.dataset.dvkMsgGeneric) return;
      var text = target.textContent.trim();
      if (!text) return;
      var d = wrapper.dataset;
      if ([d.dvkMsgMax, d.dvkMsgSoldOut, d.dvkMsgGeneric].indexOf(text) > -1 || text === target.dataset.dvkTranslated) return;

      var next = d.dvkMsgGeneric;
      // English patterns, plus the Dutch wording Shopify uses now that the store language is Dutch.
      var limit = text.match(/only add (\d+)/i) || text.match(/^all (\d+)/i) || text.match(/slechts (\d+)/i);
      if (/maximum quantity|maximale hoeveelheid|can(?:'|\u2019)t add more|^all \d+/i.test(text)) next = d.dvkMsgMax;
      else if (limit && d.dvkMsgLimit) next = d.dvkMsgLimit.replace('__N__', limit[1]);
      else if (/sold out|uitverkocht/i.test(text)) next = d.dvkMsgSoldOut;

      target.dataset.dvkTranslated = next;
      target.textContent = next;
    };

    var start = function () {
      document.querySelectorAll('.product-form__error-message-wrapper').forEach(translate);
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
          var wrapper = el && el.closest ? el.closest('.product-form__error-message-wrapper') : null;
          if (wrapper) translate(wrapper);
        });
      }).observe(document.body, { childList: true, characterData: true, subtree: true });
    };

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
